$(function () {
	$('.js-head').on('click',function () {
		$(this).siblings('.js-body').slideToggle();
		$(this).parent().toggleClass('active');
	});
});
